var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotfullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11710_7087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24857 22.7787C7.57229 23.455 6.545 22.4277 7.22127 21.7514L11.7642 17.2085H9.25913C8.30259 17.2085 8.30259 15.7556 9.25913 15.7556H13.5179C13.9191 15.7556 14.2444 16.0811 14.2444 16.4821V20.7409C14.2444 21.6974 12.7915 21.6974 12.7915 20.7409V18.236L8.24857 22.7787ZM15.7556 9.25891C15.7556 8.30236 17.2085 8.30236 17.2085 9.25891V11.764L21.7514 7.22127C22.4277 6.545 23.455 7.57229 22.7787 8.24857L18.236 12.7915H20.7411C21.6976 12.7915 21.6976 14.2444 20.7411 14.2444H16.4821C16.0809 14.2444 15.7556 13.9189 15.7556 13.5179V9.25891Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11710_7087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfullscreen);
export default __webpack_public_path__ + "static/media/notfullscreen.59827920bac926e0f670c0dba732463d.svg";
export { ForwardRef as ReactComponent };